import { createExternalRouteRef } from '@backstage/core-plugin-api';

import { createPageRoute } from '@spotify/confidence-common-react';

export const experimentsRouteRef = createPageRoute({
  id: 'confidence-experiments',
  page: { title: 'Experiments' },
});

export const workflowsRouteRef = createExternalRouteRef({
  id: 'workflows',
});

export const workflowRouteRef = createExternalRouteRef({
  id: 'workflow',
  params: ['workflow'],
});

export const workflowInstanceRouteRef = createExternalRouteRef({
  id: 'workflowInstance',
  params: ['workflow', 'id'],
});
